export default "__VITE_PUBLIC_ASSET__75fa3119__"